<template>
  <div>
    <div :class="isMobile ? 'product-m' : 'product'"  ref="overviewRef">
      <div class="word">
        <div class="word-title">解决方案</div>
        <div class="word-text">Solution</div>
      </div>
      <div class="product-content">
        <el-row :gutter="30">
          <el-col :span="5">
            <div class="tab-title" v-show="!isMobile">解决方案</div>
            <el-menu
              :default-active="defaultActive"
              :default-openeds="defaultOpeneds"
              @open="handleOpen"
              @close="handleClose"
              @select="menuSelect"
              :unique-opened="true"
              :collapse="isMobile">
              <el-menu-item :index="String(index+1)" v-for="(item, index) in productList" :key="index">
                <i class="el-icon-menu" v-show="isMobile"></i>
                <template slot="title">
                  <span class="tab-one">{{item.type}}</span>
                </template>
                <!-- <el-menu-item v-for="(one, i) in item.data" :key="i" :index="(index+1)+'-'+(i+1)"  class="tab-one-one">
                  <div :class="tabParentId==index && tabChildId==i ? 'active': ''">{{one.name}}</div>
                </el-menu-item> -->
              </el-menu-item>
            </el-menu>
          </el-col>
          <el-col :span="19">
            <el-row :gutter="20">
                <el-col :span="isMobile ? 24 : 8" v-for="(obj, i) in productList[tabParentId].data" :key="i" >
                  <el-card :body-style="{ padding: '0px' }" shadow="hover" class="cardOne">
                    <span class="spanImg" @click="enterDetail(obj)">
                      <img :src="require(`./../../assets/project/${obj.imgUrl}`)" class="image">
                    </span>
                    <div class="cardWord" @click="enterDetail(obj)">
                      <span>{{obj.name}}</span>
                      <div class="bottom clearfix">
                        <h5 class="cardBottomWord">查看详情</h5>
                      </div>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
          </el-col>
        </el-row>
        <div class="command-word">
          <!-- <el-tabs v-model="currentDropdown" @tab-click="handleCommand" type="card">
            <el-tab-pane v-for="(item, index) in productList" :label="item.type" :name="String(index)" :key="index">
              <el-row :gutter="20">
                <el-col :span="isMobile ? 24 : 8" v-for="(obj, i) in productList[tabParentId]" :key="i" >
                  <el-card :body-style="{ padding: '0px' }" shadow="hover" class="cardOne">
                    <span class="spanImg" @click="enterDetail(obj)">
                      <img :src="require(`./../../assets/project/${obj.imgUrl}`)" class="image">
                    </span>
                    <div class="cardWord" @click="enterDetail(obj)">
                      <span>{{obj.name}}</span>
                      <div class="bottom clearfix">
                        <h5 class="cardBottomWord">查看详情</h5>
                      </div>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
              <div class="seeMore" v-show="productShowListAll.length > productShowList.length"> 
                <div @click="seeMore()" class="seeMoreBtn">查看更多</div>
              </div>  
            </el-tab-pane>
          </el-tabs> -->
          <!-- <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              {{currentDropdown}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="all">全部</el-dropdown-item>
              <el-dropdown-item 
                v-for="(item, index) in productList" 
                :key="item.type"
                :command="index">
                {{item.type}}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import arrJson from "../../utils/arrJson"

export default {
  name: 'Plan',
  data() {
    return {
      isMobile: window.innerWidth < 780,
      currentDropdown: 0,
      productList: arrJson.planList,
      productShowListAll: [],
      productShowList: [],
      defaultActive: '', // 例如：第一个父菜单的第一个子项
      defaultOpeneds: [], // 例如：展开第一个父菜单
      tabParentId: 0,
      tabChildId: 0
    }
  },
  mounted() {
    window.addEventListener("resize", this.initFunc)
    if(window.sessionStorage.getItem("scroll")){
      setTimeout(() => {
        window.scrollTo({
          top: this.isMobile ? 180 : 500,
          behavior: 'smooth' // 平滑滚动
        });
      }, 0);
      window.sessionStorage.removeItem("scroll")
    }
    this.setInitId()
  },
  methods: {
    setInitId(){
      const classId = window.sessionStorage.getItem('productClassId');
      if(classId && classId>=0 && classId<=this.productList.length){
        this.tabParentId = parseInt(classId-1)
        this.tabChildId = 0
        this.defaultActive = classId+'-1'
        this.defaultOpeneds = [String(classId)]
        // console.log("tabParentId", this.tabParentId, "tabChildId", this.tabChildId, "defaultActive", this.defaultActive, "defaultOpeneds", this.defaultOpeneds)
        window.sessionStorage.removeItem("productClassId")

        const element = this.$refs.overviewRef
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            })
          }
      }else{
        this.tabParentId = 0
        this.tabChildId = 0
        this.defaultActive = '1-1'
        this.defaultOpeneds = ['1']
      }
    },
    handleCommand(e){
      this.currentDropdown = e.index
      this.setShowPro(e.index)
    },
    setShowPro(i){
      if(i>=0){
        this.productShowListAll = this.productList[i].data 
        this.productShowList = this.productShowListAll
      } else {
        this.productShowListAll = this.productList[0].data
        this.productShowList = this.productList[0].data.slice(0, 6)
      }
    },
    seeMore() {
      const currentNum = this.productShowList.length
      if(currentNum<this.productShowListAll.length) {
        this.productShowList = this.productShowListAll.slice(0, currentNum+6)
      }
    },
    enterDetail(obj) {
      window.sessionStorage.setItem('productClassId', this.tabParentId+1);
      this.$router.push({ path: '/planDetail/'+obj.id })
    },
    initFunc() {
      this.isMobile = window.innerWidth < 780
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
      this.tabParentId = key-1
      this.tabChildId = 0
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    menuSelect(key, keyPath) {
      console.log(key, keyPath);
      this.tabParentId = keyPath[0]-1
      this.tabChildId = key.split('-')[1]-1
      console.log("this.tabParentId", this.tabParentId, "this.tabChildId", this.tabChildId)
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.initFunc)
  },
  props: {
    msg: String
  }
}
</script>


<style scoped lang="less">
.product{
  background: #f5f6fa;
  width: 100%;
  .word{
    padding: 60px 0 40px;
    .word-title{
      line-height: 44px;
      font-size: 32px;
      font-weight: bold;
      text-align: center;
      color: #313E47;
    }
    .word-text{
      color: #313E47;
      font-size: 16px;
      line-height: 26px;
      font-weight: normal;
      text-align: center;
    }
  }
  .product-content{
    max-width: 1400px;
    padding: 0 0 70px;
    margin: 0 auto;
    overflow: hidden;
    .tab-title{
      text-align: center;
      background-color: #384C5C;
      padding: 26px 30px;
      color: #fff;
      font-size: 20px;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
    }
    .tab-one{
      font-size: 16px;
      color: #000;
    }
    .is-opened{
      .tab-one{
        color: #00D0FF;
      }
    }
    .tab-one-one{
      font-size: 13px;
      color: #989898;
      .active{
        // color: #00D0FF; 
      }
    }
    .command-word{
      display: inline-block;
      cursor: pointer;
    }
    .el-card{
      margin: 0 10px 20px;
      text-align: left;
      border-radius: 14px;
    }
    .cardOne{
      background: #d6dde8;
      box-shadow: #e8e8e8 1px 2px 5px;
      .spanImg{
        display: block;
        overflow: hidden;
      }
      .image{
        max-width: 100%;
        height: 250px;
        display: block;
        transition: all 0.6s;
        -ms-transition: all 0.8s;
        margin: 0 auto;
      }
      .image:hover{
        transform: scale(1.3);
        -ms-transform: scale(1.3);
      }
      .cardWord{
        padding: 14px;
        background: #fff;
        z-index: 10;
        text-align: center;
        color: #202020;
        font-size: 18px;
        height: 112px;
      }
      .cardBottomWord{
        font-size: 14px;
        color: #fff;
        display: inline-block;
        border-radius: 20px;
        padding: 12px 40px;
        margin: 16px 0;
        background: #384C5C;
        cursor: pointer;
      }
      .cardBottomWord:hover{
          background: #00D0FF;
        }
    }
    .seeMore{
      text-align: center;
      .seeMoreBtn{
        font-size: 16px;
        color: #0089fe;
        border: 1px solid #0089fe;
        padding: 14px 40px;
        display: inline-block;
        margin: 50px auto 0;
        cursor: pointer;
      }
    }
  }
}
.product-m{
  background: #f5f6fa;
  width: 100%;
  .word{
    padding: 0.8rem 0;
    .word-title{
      font-size: 0.6rem;
      line-height: 1.2rem;
      text-align: center;
    }
    .word-gray{
      width: 1.6rem;
      height: 0.04rem;
      background: #d6d6d6;
      margin: 0 auto;
    }
    .word-text{
      line-height: 0.6rem;
      color: #9b9b9b;
      font-size: 0.4rem;
      text-align: center;
    }
  }
  .product-content{
    padding: 0 0 1rem;
    margin: 0.1rem 0.3rem;
    .command-word{
      display: inline-block;
      font-size: 0.6rem;
    }
    .el-card{
      margin: 0.2rem 0.4rem;
      text-align: left;
      border-radius: 0.3rem;
    }
    /deep/ .el-dropdown .el-dropdown-link:focus {
      outline: 0;
    }
    .cardOne{
      background: #d6dde8;
      box-shadow: #e8e8e8 0.02rem 0.04rem 0.1rem;
      .spanImg{
        display: block;
        overflow: hidden;
      }
      .image{
        max-width: 100%;
        height: 3.6rem;
        display: block;
        transition: all 0.6s;
        -ms-transition: all 0.8s;
        margin: 0 auto;
      }
      .image:hover{
        transform: scale(1.3);
        -ms-transform: scale(1.3);
      }
      .cardWord{
        padding: 0.3rem;
        background: #fff;
        z-index: 10;
        text-align: center;
        color: #202020;
        font-size: 0.4rem;
      }
      .cardBottomWord{
        font-size: 0.3rem;
        color: #2c3e56;
        font-weight: 400;
        border: 1px solid #303032;
        display: inline-block;
        border-radius: 0.4rem;
        padding: 0.12rem 0.6rem;
        background: #f5f6fa;
        margin: 0.3rem 0;
      }
    }
    .seeMore{
      text-align: center;
      .seeMoreBtn{
        font-size: 0.34rem;
        color: #0089fe;
        border: 0.02rem solid #0089fe;
        padding: 0.3rem 0.8rem;
        display: inline-block;
        margin: 0.6rem auto 0rem;
      }
    }
  }
}

</style>
